export default "__VITE_ASSET__903d216d__"